"use strict";

const initializeOfferAndMedia = () => {
    const $videos = $(".js-offerAndMedia-video");

    $videos.each(function () {
        const $container = $(this);
        const $thumbnail = $container.find(".js-offerAndMedia-thumbnail");
        const $content   = $container.find(".js-offerAndMedia-content");
        const $iframe    = $container.find(".js-offerAndMedia-iframe");
        const videoId    = $container.data("id");

        $container.on("click", (e) => {
            e.preventDefault();
            $thumbnail.add($content).addClass("d-none");
            $iframe.removeClass("d-none");
            $iframe.find("iframe").attr(
                "src",
                `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&rel=0&wmode=transparent`
            );
        });
    });
};

export default initializeOfferAndMedia;
